<div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700">
  <!-- Header -->
  <div class="flex items-center justify-between px-5 py-4 border-b border-gray-100 dark:border-gray-700">
    <div>
      <h3 class="text-sm font-semibold text-gray-900 dark:text-white">Historial de workflows</h3>
      <!-- inc40 — el nombre del registro, no «CONTACT #255». El id se conserva al lado
           porque es lo que se usa para depurar y para hablar con soporte. -->
      <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{{ registroLabel }}</p>
    </div>
    <div class="flex items-center gap-3">
      <label class="flex items-center gap-1.5 text-xs text-gray-500 cursor-pointer">
        <input type="checkbox" [(ngModel)]="includeTestRuns" (change)="load()"
               class="w-3.5 h-3.5 rounded border-gray-300 text-amber-600 focus:ring-amber-500"/>
        Incluir pruebas
      </label>
      <button (click)="load()" [disabled]="loading"
              class="p-1.5 text-gray-400 hover:text-gray-600 rounded transition-colors" title="Recargar">
        <svg class="w-4 h-4" [class.animate-spin]="loading" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
        </svg>
      </button>
    </div>
  </div>

  <div class="p-4">
    @if (loading && !history) {
      <div class="flex items-center justify-center py-8 text-gray-400">
        <svg class="animate-spin w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
        </svg>
        Cargando historial...
      </div>
    } @else if (error) {
      <p class="text-sm text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20 p-3 rounded-lg">{{ error }}</p>
    } @else if (!history || history.items.length === 0) {
      <p class="text-sm text-gray-400 dark:text-gray-500 text-center py-8">
        Este registro no ha participado en ningún workflow todavía.
      </p>
    } @else {
      <div class="space-y-3">
        @for (item of history.items; track item.enrollmentId) {
          <div class="p-3 border border-gray-100 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700/30 transition-colors">
            <div class="flex items-start justify-between gap-3 mb-2">
              <div class="flex-1 min-w-0">
                <div class="flex items-center gap-2 flex-wrap">
                  <span class="text-sm font-medium text-gray-900 dark:text-white truncate">
                    {{ item.workflowName ?? 'Workflow #' + item.workflowId }}
                  </span>
                  @if (isTestRun(item)) {
                    <span class="px-1.5 py-0.5 rounded text-[10px] font-bold bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400">
                      Prueba
                    </span>
                  }
                  <span class="px-2 py-0.5 rounded-full text-xs font-medium" [ngClass]="getStatusClass(item.status)">
                    {{ item.statusLabel || statusText(item.status) }}
                  </span>
                </div>
                <div class="flex flex-wrap gap-3 mt-1 text-xs text-gray-400">
                  <span>Inscripción #{{ item.enrollmentId }}</span>
                  @if (item.enrolledAt) {
                    <span>{{ item.enrolledAt | date:'dd/MM/yyyy HH:mm' }}</span>
                  }
                  @if (item.runCount) {
                    <span>{{ item.runCount }} ejecución(es)</span>
                  }
                  @if (item.stepCount) {
                    <span>{{ item.stepCount }} paso(s)</span>
                  }
                  @if (item.failedStepCount) {
                    <span class="text-red-500">{{ item.failedStepCount }} fallido(s)</span>
                  }
                  @if (item.exitReasonLabel || item.exitReason) {
                    <span>{{ item.exitReasonLabel || exitReasonText(item.exitReason) }}</span>
                  }
                </div>
              </div>
              <button (click)="timelineEnrollmentId = item.enrollmentId"
                      class="shrink-0 px-2.5 py-1.5 text-xs border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300 transition-colors flex items-center gap-1">
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
                </svg>
                Timeline
              </button>
            </div>
            @if (item.lastError) {
              <p class="text-xs text-red-500 font-mono truncate" [title]="item.lastError">{{ item.lastError }}</p>
            }
          </div>
        }
      </div>
    }
  </div>
</div>

<!-- Timeline modal -->
@if (timelineEnrollmentId) {
  <app-workflow-timeline-modal
    [enrollmentId]="timelineEnrollmentId"
    (closed)="timelineEnrollmentId = null">
  </app-workflow-timeline-modal>
}
